<template>
  <v-container
    ref="containerRef"
    id="userEditUnitContainer"
    fluid
    class="edit-user-unit-container"
    :class="[activecourse[0].baseYear, { 'top-38': hasNotifications.length }]"
    @scroll="scrollHandler"
  >
    <div class="w-100">
      <v-divider v-if="hasAssignments" class="dashed my-10"></v-divider>

      <div
        v-if="hasAssignments"
        id="start"
        class="font-weight-bold mb-3"
        :class="{ 'px-0': smAndDown, 'px-10': mdAndUp }"
      >
        {{ $t('unitStudy.sections.assignments') }}
      </div>
      <div
        v-if="hasAssignments"
        class="unit-assignments mb-10"
        :class="{ 'px-0': smAndDown, 'px-10': mdAndUp }"
      >
        <!-- {{unit.status}} -->
        <div v-if="unit.listen">
          <div class="_flex-this mb-6">
            <div>
              <div v-if="!onLine" class="_flex-this align-baseline">
                <input
                  type="checkbox"
                  id="listen-checkbox"
                  :disabled="unit.status === 'archived'"
                  v-model="listenConfirmed"
                  class="mt-0 pt-0 mr-3 assignment-checkbox-input"
                  @change="updateAssignments()"
                />
                <div class="_flex-this" style="margin-top: 2px">
                  <span class="font-weight-bold">{{ listenLabel }}:</span>
                </div>
              </div>
              <v-checkbox
                v-else
                v-model="listenConfirmed"
                density="compact"
                hide-details
                :disabled="unit.status === 'archived'"
                class="mt-0 pt-0"
                @update:model-value="updateAssignments()"
              >
                <template #label>
                  <div class="_flex-this" style="margin-top: 2px">
                    <span class="font-weight-bold">{{ listenLabel }}:</span>
                  </div>
                </template>
              </v-checkbox>
            </div>
            <span v-html="unit.listen" class="label-text"></span>
          </div>
        </div>
        <div v-if="unit.complete">
          <div class="_flex-this mb-6">
            <div>
              <div v-if="!onLine" class="_flex-this align-baseline">
                <input
                  type="checkbox"
                  id="complete-checkbox"
                  :disabled="unit.status === 'archived'"
                  v-model="completeConfirmed"
                  class="mt-0 pt-0 mr-3 assignment-checkbox-input"
                  @change="updateAssignments()"
                />
                <div class="_flex-this" style="margin-top: 2px">
                  <span class="font-weight-bold">{{ completeLabel }}:</span>
                </div>
              </div>
              <v-checkbox
                v-else
                v-model="completeConfirmed"
                density="compact"
                hide-details
                :disabled="unit.status === 'archived'"
                class="mt-0 pt-0"
                @update:model-value="updateAssignments()"
              >
                <template #label>
                  <div class="_flex-this" style="margin-top: 2px">
                    <span class="font-weight-bold">{{ completeLabel }}:</span>
                  </div>
                </template>
              </v-checkbox>
            </div>
            <span v-html="unit.complete" class="label-text"></span>
          </div>
        </div>
        <div v-if="unit.continueLearning">
          <div class="_flex-this">
            <div>
              <div v-if="!onLine" class="_flex-this align-baseline">
                <input
                  type="checkbox"
                  id="continue-checkbox"
                  :disabled="unit.status === 'archived'"
                  v-model="continueConfirmed"
                  class="mt-0 pt-0 mr-3 assignment-checkbox-input"
                  @change="updateAssignments()"
                />
                <div class="_flex-this" style="margin-top: 2px">
                  <span class="font-weight-bold"
                    >{{ continueLearningLabel }}:</span
                  >
                </div>
              </div>
              <v-checkbox
                v-else
                v-model="continueConfirmed"
                density="compact"
                hide-details
                :disabled="unit.status === 'archived'"
                class="mt-0 pt-0"
                @update:model-value="updateAssignments()"
              >
                <template #label>
                  <div class="_flex-this" style="margin-top: 2px">
                    <span class="font-weight-bold"
                      >{{ continueLearningLabel }}:</span
                    >
                  </div>
                </template>
              </v-checkbox>
            </div>
            <span v-html="unit.continueLearning" class="label-text"></span>
          </div>
        </div>
      </div>

      <div
        v-intersection="{ callback: onWaypoint, options: { threshold: [0] } }"
        id="truth"
        class="p-content-container"
      >
        <div class="flex-container mt-5">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.truth') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <UserVersesQuotes
          :content="unit.truthVersesQuotes"
          section="truthVersesQuotes"
        />

        <v-divider v-if="unit.truthVersesQuotes" class="dashed"></v-divider>

        <div
          v-if="unit.truthInBible"
          v-html="unit.truthInBible"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>

        <UserStudyQuestions
          ref="truthStudyQuestions"
          :unitbackdoor="unitbackdoor"
          :backdoor="backdoor"
          :content="unit.truthStudyQuestions"
          :status="unit.status"
          section="truthStudyQuestions"
          @allstudyquestions="studyQuestionsChild"
          @questionsLoaded="onQuestionsLoaded"
        />

        <div
          v-if="unit.truthBodyContent"
          v-html="unit.truthBodyContent"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>
      </div>

      <div
        v-intersection="{ callback: onWaypoint, options: { threshold: [0.5] } }"
        id="equip"
        class="p-content-container"
      >
        <div class="flex-container">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.equipping') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <div
          v-if="unit.equipBodyContent"
          v-html="unit.equipBodyContent"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>

        <UserStudyQuestions
          ref="equipStudyQuestions"
          :unitbackdoor="unitbackdoor"
          :backdoor="backdoor"
          :content="unit.equipStudyQuestions"
          :status="unit.status"
          section="equipStudyQuestions"
          @allstudyquestions="studyQuestionsChild"
          @questionsLoaded="onQuestionsLoaded"
        />
      </div>

      <div
        v-intersection="{
          callback: onWaypoint,
          options: { threshold: [0.25] },
        }"
        id="application"
        class="p-content-container"
      >
        <div class="flex-container">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.accountability') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <div
          v-if="unit.accountBodyContent"
          v-html="unit.accountBodyContent"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>

        <UserStudyQuestions
          ref="accountStudyQuestions"
          :unitbackdoor="unitbackdoor"
          :backdoor="backdoor"
          :content="unit.accountStudyQuestions"
          :status="unit.status"
          section="accountStudyQuestions"
          @allstudyquestions="studyQuestionsChild"
          @questionsLoaded="onQuestionsLoaded"
        />
      </div>

      <div
        v-intersection="{
          callback: onWaypoint,
          options: { threshold: [0.25] },
        }"
        id="mission"
        class="p-content-container"
      >
        <div class="flex-container">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.mission') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <div
          v-if="unit.missionBodyContent"
          v-html="unit.missionBodyContent"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>

        <UserStudyQuestions
          ref="missionStudyQuestions"
          :unitbackdoor="unitbackdoor"
          :backdoor="backdoor"
          :content="unit.missionStudyQuestions"
          :status="unit.status"
          section="missionStudyQuestions"
          @allstudyquestions="studyQuestionsChild"
          @questionsLoaded="onQuestionsLoaded"
        />
      </div>

      <div
        v-intersection="{
          callback: onWaypoint,
          options: { threshold: [0.25] },
        }"
        id="supplication"
        class="p-content-container"
      >
        <div class="flex-container">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.supplication') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <UserVersesQuotes
          :content="unit.supplicationVerseQuotes"
          section="supplicationVerseQuotes"
        />

        <v-divider
          v-if="unit.supplicationVerseQuotes"
          class="dashed"
        ></v-divider>

        <div
          v-if="unit.supplicationBodyContent"
          v-html="unit.supplicationBodyContent"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>

        <UserStudyQuestions
          ref="supplicationStudyQuestions"
          :unitbackdoor="unitbackdoor"
          :backdoor="backdoor"
          :content="unit.supplicationStudyQuestions"
          :status="unit.status"
          section="supplicationStudyQuestions"
          @allstudyquestions="studyQuestionsChild"
          @questionsLoaded="onQuestionsLoaded"
        />
      </div>

      <div v-if="unit.footnotesBodyContent">
        <div class="flex-container">
          <div
            class="font-weight-bold text-h6 base-year"
            :class="activecourse[0].baseYear"
          >
            {{ $t('unitStudy.sections.footnotes') }}
          </div>
          <v-divider class="dashed" style="margin-top: 15px"></v-divider>
        </div>

        <div
          v-html="unit.footnotesBodyContent"
          id="footer-section"
          class="mb-7 mt-12"
          @mouseup="handleMouseUp"
        ></div>
      </div>

      <v-btn
        variant="flat"
        :loading="completingUnit"
        :disabled="completingUnit"
        class="font-weight-bold"
        :class="activecourse[0].baseYear"
        @click="completeUnit()"
      >
        <span v-if="unit.status !== 'archived'">{{
          $t('unitStudy.actions.completeUnit')
        }}</span>
        <span v-else>{{ $t('unitStudy.actions.reactivateUnit') }}</span>
      </v-btn>
    </div>
    <CommentDialog
      :key="activeParagraphId + '|' + (activeCommentText || '')"
      v-model="commentDialogOpen"
      :paragraph-id="activeParagraphId"
      :comment="activeCommentText"
      :saving="savingComment"
      :title="
        activeCommentText
          ? $t('unitStudy.comments.editComment')
          : $t('unitStudy.comments.addComment')
      "
      :activecourse="activecourse"
      @save="onDialogSave"
      @cancel="onDialogCancel"
    />
    <!-- move the toolbar OUT of the content subtree -->
    <teleport to="body">
      <HighlightToolbar
        ref="toolbar"
        :visible="showToolbar"
        :x="x"
        :y="y"
        :mode="mode"
        :wrap="shouldWrap"
        :placement="placement"
        @highlight="applyHighlight"
        @remove="removeHighlight"
        @recolor="recolorHighlight"
      />
    </teleport>
  </v-container>
</template>

<script>
  import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
  import HighlightToolbar from '@/components/utilities/HighlightToolbar.vue'
  import { useTextHighlighter } from '@/helpers/useTextHighlighter'
  import db from '@/firebase/init'
  import { mapGetters } from 'vuex'
  import UserStudyQuestions from '@/components/utilities/UserStudyQuestions'
  import UserVersesQuotes from '@/components/utilities/UserVersesQuotes'
  import { useIntersectionObserver } from '@vueuse/core'
  import CommentDialog from '@/components/comments/CommentDialog.vue'

  const vIntersection = {
    mounted(el, binding) {
      const { callback, options } = binding.value || {}
      useIntersectionObserver(
        el,
        ([{ isIntersecting }]) => {
          if (callback && typeof callback === 'function') {
            callback({
              el,
              going: isIntersecting ? 'in' : 'out',
              direction: 'top', // You can calculate direction if needed
            })
          }
        },
        options || {}
      )
    },
  }

  export default {
    name: 'UserEditUnit',
    props: ['unit', 'unitbackdoor', 'activecourse', 'hasNotifications'],
    directives: {
      intersection: vIntersection,
    },
    components: {
      HighlightToolbar,
      UserStudyQuestions,
      UserVersesQuotes,
      CommentDialog,
    },
    setup() {
      const containerRef = ref(null)
      const { proxy } = getCurrentInstance()
      const ignoreSelectionChanges = ref(false)
      const toolbar = ref(null)

      // Firestore persistence hook
      const onChange = async (action, payload) => {
        await Promise.resolve()
        if (action === 'highlight' && payload?.wrapper) {
          const paragraphEl = payload.wrapper.closest('[id]')
          const key = paragraphEl?.id
          if (!paragraphEl || !key) return
          const id = await proxy?.saveHighlight(null, action, {
            paragraphEl,
            key,
          })
          if (id) payload.wrapper.setAttribute('data-highlight-id', id)
          return
        }
        if (payload?.paragraphEl && payload?.key) {
          await proxy?.saveHighlight(null, action, {
            paragraphEl: payload.paragraphEl,
            key: payload.key,
          })
        }
      }

      const {
        showToolbar,
        selectionIsValid,
        mode,
        x,
        y,
        handleMouseUp,
        handleScrollOrResize,
        applyHighlight,
        removeHighlight,
        setSelectionFromText,
        registerToolbarEl,
        shouldWrap,
        placement,
        recolorHighlight,
        showToolbarForHighlightNode,
        hideToolbar,
      } = useTextHighlighter(containerRef, { onChange })

      const onHighlightTap = (e) => {
        const el = e.target?.closest?.('.highlighted')
        if (!el) return
        e.preventDefault()
        e.stopPropagation()
        // mute selectionchange while we open the toolbar
        ignoreSelectionChanges.value = true
        showToolbarForHighlightNode(el) // from the composable
        // re-enable after UI settles
        setTimeout(() => {
          ignoreSelectionChanges.value = false
        }, 200)
      }

      // Debounce until selection stops moving; then show pill on mobile
      function onSelectionChange() {
        if (ignoreSelectionChanges.value) return
        const sel = window.getSelection?.()

        if (!sel || sel.isCollapsed) return
        // validate selection (sets selectionIsValid, computes x/y)
        handleMouseUp()
      }

      function handlePointerUp(e) {
        // If the pointerup happened inside the teleported toolbar, ignore it
        const rootEl =
          (toolbar.value && (toolbar.value.$el || toolbar.value.el)) || null
        if (rootEl && e && rootEl.contains(e.target)) return
        handleMouseUp()
      }

      function onResize() {
        handleScrollOrResize()
      }

      function onOutsideTap(e) {
        if (!showToolbar.value) return

        const toolbarRoot =
          (toolbar.value && (toolbar.value.$el || toolbar.value.el)) || null
        if (toolbarRoot && toolbarRoot.contains(e.target)) return // clicks inside toolbar: ignore

        // If there is an active selection inside the content, don't auto-close
        const contentEl =
          (containerRef.value &&
            (containerRef.value.$el || containerRef.value)) ||
          null
        const sel = window.getSelection?.()
        if (
          contentEl &&
          sel &&
          sel.rangeCount &&
          !sel.isCollapsed &&
          contentEl.contains(sel.getRangeAt(0).commonAncestorContainer)
        ) {
          return
        }

        hideToolbar() // dismiss + clear selection
      }

      onMounted(() => {
        // use the exposed el first, then $el as a fallback
        registerToolbarEl(toolbar.value?.el || toolbar.value?.$el || null)

        const contentEl =
          (containerRef.value &&
            (containerRef.value.$el || containerRef.value)) ||
          null
        if (contentEl) {
          // Capture + non-passive so preventDefault works and we run before default selection/caret
          const opts = { capture: true, passive: false }
          contentEl.addEventListener('pointerdown', onHighlightTap, opts)
          contentEl.addEventListener('touchstart', onHighlightTap, opts)
          contentEl.addEventListener('click', onHighlightTap, opts)
        }

        // Dismiss toolbar on outside *click* (not pointerdown) so long-press selecting won't be killed
        document.addEventListener('click', onOutsideTap, true)

        window.addEventListener('resize', onResize)
        document.addEventListener('selectionchange', onSelectionChange, true)
        document.addEventListener('pointerup', handlePointerUp, true)
        document.addEventListener('scroll', handleScrollOrResize, true)
      })

      onBeforeUnmount(() => {
        registerToolbarEl(null)

        const contentEl =
          (containerRef.value &&
            (containerRef.value.$el || containerRef.value)) ||
          null
        if (contentEl) {
          const opts = { capture: true, passive: false }
          contentEl.removeEventListener('pointerdown', onHighlightTap, opts)
          contentEl.removeEventListener('touchstart', onHighlightTap, opts)
          contentEl.removeEventListener('click', onHighlightTap, opts)
        }

        document.removeEventListener('click', onOutsideTap, true)

        window.removeEventListener('resize', onResize)
        document.removeEventListener('selectionchange', onSelectionChange, true)
        document.removeEventListener('pointerup', handlePointerUp, true)
        document.removeEventListener('scroll', handleScrollOrResize, true)
      })

      return {
        containerRef,
        toolbar,
        showToolbar,
        selectionIsValid,
        mode,
        x,
        y,
        handleMouseUp,
        handleScrollOrResize,
        applyHighlight,
        removeHighlight,
        setSelectionFromText,
        shouldWrap,
        placement,
        recolorHighlight,
        showToolbarForHighlightNode,
      }
    },
    data() {
      return {
        feedback: null,
        isEditingUnit: false,
        backdoor: 0,
        listenConfirmed: null,
        completeConfirmed: null,
        continueConfirmed: null,
        completingUnit: false,
        unitActive: true,
        unitStatus: 'active',
        userUnit: [],
        windowWidth: window.innerWidth,
        wayPointOptions: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: Array(101)
            .join(0)
            .split(0)
            .map((n, i) => i / 100), // [0.00, 0.01, ...0.99, 1]
        },
        selectedRange: null,
        showTools: false,
        showComment: false,
        selectedComment: '',
        selectedText: '',
        activeCommentID: null,
        commentsArray: [],
        commentDialogOpen: false,
        activeParagraphId: '',
        activeCommentText: '',
        savingComment: false,
        highlightExists: false,
        unitNotes: false,
        onLine: navigator.onLine,
        allQuestions: [],
        loadedSections: 0,
        totalSections: 5,
      }
    },
    computed: {
      ...mapGetters('UserData', ['isAuthenticated']),
      smAndDown() {
        const d = this.$vuetify && this.$vuetify.display
        if (d && typeof d.smAndDown !== 'undefined') return d.smAndDown
        // fallback so it never crashes during early mount
        if (typeof window !== 'undefined' && window.matchMedia) {
          return window.matchMedia('(max-width: 960px)').matches
        }
        return false
      },
      mdAndUp() {
        const d = this.$vuetify && this.$vuetify.display
        if (d && typeof d.mdAndUp !== 'undefined') return d.mdAndUp
        if (typeof window !== 'undefined' && window.matchMedia) {
          return window.matchMedia('(min-width: 960px)').matches
        }
        return true
      },
      listenLabel: {
        get() {
          return this.unit.listenLabel
            ? this.unit.listenLabel.toUpperCase()
            : 'LISTEN'
        },
        set(value) {
          return value
        },
      },
      completeLabel: {
        get() {
          return this.unit.completeLabel
            ? this.unit.completeLabel.toUpperCase()
            : 'COMPLETE'
        },
        set(value) {
          return value
        },
      },
      continueLearningLabel: {
        get() {
          return this.unit.continueLearningLabel
            ? this.unit.continueLearningLabel.toUpperCase()
            : 'CONTINUE'
        },
        set(value) {
          return value
        },
      },
      hasAssignments() {
        return Boolean(
          this.unit &&
            (this.unit.listen ||
              this.unit.complete ||
              this.unit.continueLearning)
        )
      },
    },
    watch: {
      'activecourse.0.baseYear': {
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            // console.log('activecourse[0].baseYear changed:', newVal); // Debug log
            this.$emit('baseYearChanged', newVal)
            this.applyRefTaggerWithDelay() // Apply RefTagger when baseYear changes
          }
        },
      },
      unit: function (newVal, oldVal) {
        // watch it
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            this.applyRefTaggerWithDelay() // Apply RefTagger when unit changes
          })
        }
      },
    },
    mounted() {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)

      this.initializeRefTagger()
      this.$nextTick(() => {
        this.applyRefTaggerWithDelay() // Apply RefTagger on initial load
        this.assignBlockIDs()
      })

      // Emit the initial baseYear when the component is mounted
      // console.log('Mounted: Emitting baseYearChanged:', this.activecourse[0].baseYear); // Debug log
      this.$emit('baseYearChanged', this.activecourse[0].baseYear)

      this.commentHandlerDebounced = (() => {
        let t
        return () => {
          clearTimeout(t)
          // two RAFs help ensure we’re after other layout/innerHTML work
          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              this.commentHandler()
            })
          )
        }
      })()
    },
    beforeUnmount() {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {
      scrollToTop(id) {
        document.getElementById(id).scrollIntoView({ behavior: 'auto' })
      },
      // Handle the event when a child component loads its questions
      onQuestionsLoaded(questions) {
        this.loadedSections += 1
        this.allQuestions.push(...questions) // Add all questions to the list

        // If all sections are loaded, assign numbers
        if (this.loadedSections === this.totalSections) {
          this.assignNumbersToQuestions()
        }
      },

      assignNumbersToQuestions() {
        let questionCounter = 1
        this.allQuestions.forEach((question) => {
          question.questionNumber = questionCounter // Assign the question number
          questionCounter++
        })

        // Update each child component with the correct portion of the questions
        const section1Count = this.unit.truthStudyQuestions.length
        const section2Count =
          section1Count + this.unit.equipStudyQuestions.length
        const section3Count =
          section2Count + this.unit.accountStudyQuestions.length
        const section4Count =
          section3Count + this.unit.missionStudyQuestions.length

        this.$refs.truthStudyQuestions.combinedArray = this.allQuestions.slice(
          0,
          section1Count
        )
        this.$refs.equipStudyQuestions.combinedArray = this.allQuestions.slice(
          section1Count,
          section2Count
        )
        this.$refs.accountStudyQuestions.combinedArray =
          this.allQuestions.slice(section2Count, section3Count)
        this.$refs.missionStudyQuestions.combinedArray =
          this.allQuestions.slice(section3Count, section4Count)
        this.$refs.supplicationStudyQuestions.combinedArray =
          this.allQuestions.slice(section4Count)

        // ensure the freshly-rendered SQ blocks get IDs
        this.$nextTick(() => {
          this.assignBlockIDs()
          // Study questions render asynchronously; re-run scripture tagging afterward.
          this.applyRefTaggerWithDelay()
        })
      },
      updateOnlineStatus(e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      scrollHandler(e) {
        this.isVisible = e.target.scrollTop < 10 ? false : true
        this.$emit('changeV', this.isVisible)
        this.$emit('position', e.target.scrollTop)
        if (this.handleScrollOrResize) this.handleScrollOrResize()
      },
      initializeRefTagger() {
        if (!window.refTaggerInitialized) {
          window.refTaggerInitialized = true // Flag to ensure script is only loaded once

          window.refTagger = {
            settings: {
              bibleVersion: 'ESV', // Default Bible version
              tagChapters: true, // Tag chapter references
              noSearchClassNames: ['noTag'], // Classes to exclude from tagging
              roundCorners: true, // Popup style
              socialSharing: ['twitter', 'facebook'], // Enable social sharing
              tooltipStyle: 'light', // Tooltip style
              disableFootnotes: false, // Disable footnotes
              bibleReader: 'bible.faithlife',
              caseInsensitive: !false,
              customStyle: {
                heading: {
                  // backgroundColor : backgroundColor,
                  color: '#ffffff',
                },
                body: {
                  color: '#202020',
                  // fontFamily : "Verdana, Geneva, sans-serif",
                  fontSize: '18px',
                },
              },
            },
          }
          ;(function (d, t) {
            var n = d.querySelector('[nonce]')
            var g = d.createElement(t),
              s = d.getElementsByTagName(t)[0]
            g.src = 'https://api.reftagger.com/v2/RefTagger.js'
            g.onload = function () {
              // console.log('RefTagger script loaded');
              if (window.refTagger && window.refTagger.tag) {
                // console.log('RefTagger initialized');
                window.refTagger.tag()
              }
            }
            if (n) {
              g.setAttribute('nonce', n.nonce || n.getAttribute('nonce'))
            }
            s.parentNode.insertBefore(g, s)
          })(document, 'script')
        }
      },
      applyRefTagger() {
        // console.log('applyRefTagger');
        if (window.refTagger && window.refTagger.tag) {
          // console.log('applyRefTagger 2');
          window.refTagger.tag()
        }
      },
      applyRefTaggerWithDelay() {
        // console.log('applyRefTaggerWithDelay');
        setTimeout(() => {
          this.applyRefTagger()
        }, 1500) // Adjust the delay as needed
      },
      completeUnit() {
        this.completingUnit = true

        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id

        this.unitActive = !this.unitActive

        // console.log('1 ', this.unitActive)
        var coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef = coursecontentRef.where('isUnitStatus', '==', 'yes')
        coursecontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                doc.ref.update({
                  unitActive: this.unitActive,
                })
              })
            } else {
              // console.log("No such document!")
              db.collection('coursecontent').add({
                courseID: courseID,
                sectionID: sectionID,
                unitID: unitID,
                isUnitStatus: 'yes',
                unitActive: this.unitActive,
              })
            }
          })
          .then(() => {
            // console.log('complete')
            setTimeout(() => {
              this.completingUnit = false
            }, 500)
            this.init()
          })
          .catch(function (error) {
            console.log('Error getting document:', error)
          })
      },
      updateAssignments() {
        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id
        let listenConfirmed = this.listenConfirmed ? this.listenConfirmed : null
        let completeConfirmed = this.completeConfirmed
          ? this.completeConfirmed
          : null
        let continueConfirmed = this.continueConfirmed
          ? this.continueConfirmed
          : null

        var coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef = coursecontentRef.where('isAssignments', '==', 'yes')
        coursecontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                // console.log("Document data:", doc.data())
                if (
                  !listenConfirmed &&
                  !completeConfirmed &&
                  !continueConfirmed
                ) {
                  doc.ref.delete()
                } else {
                  doc.ref.update({
                    listenConfirmed: listenConfirmed,
                    completeConfirmed: completeConfirmed,
                    continueConfirmed: continueConfirmed,
                  })
                }
              })
            } else {
              // console.log("No such document!")
              db.collection('coursecontent').add({
                courseID: courseID,
                sectionID: sectionID,
                unitID: unitID,
                isAssignments: 'yes',
                listenConfirmed: listenConfirmed,
                completeConfirmed: completeConfirmed,
                continueConfirmed: continueConfirmed,
              })
            }
          })
          .then(() => {
            // console.log('complete')
            this.init()
          })
          .catch(function (error) {
            console.log('Error getting document:', error)
          })
      },
      studyQuestionsChild(value) {
        // update the property with any Study Questions
        if (value.section == 'truthStudyQuestions') {
          if (value.questions.length)
            this.unit.truthStudyQuestions = value.questions
          else this.unit.truthStudyQuestions = []
        }

        if (value.section == 'equipStudyQuestions') {
          if (value.questions.length)
            this.unit.equipStudyQuestions = value.questions
          else this.unit.equipStudyQuestions = []
        }

        if (value.section == 'accountStudyQuestions') {
          if (value.questions.length)
            this.unit.accountStudyQuestions = value.questions
          else this.unit.accountStudyQuestions = []
        }
      },
      versesQuotesChild(value) {
        // update the property with any Study Questions
        if (value.section == 'truthVersesQuotes') {
          if (value.versesquotes.length)
            this.unit.truthVersesQuotes = value.versesquotes
          else this.unit.truthVersesQuotes = []
        }
      },
      // eslint-disable-next-line
      onWaypoint({ el, going, direction }) {
        if (going === 'in') {
          if (el.id.length > 0 && direction) {
            const parentNode = document.getElementById('team-container')
            const allMenuItems =
              parentNode.getElementsByClassName('unit-icon active')

            if (allMenuItems.length > 0) {
              allMenuItems[0].classList.remove('active')
            }

            const activeElement = document.getElementById('menu-' + el.id)
            if (activeElement) {
              activeElement.classList.add('active')
            }
          }
        }
      },
      openCommentModule(doc) {
        // Target paragraph element is passed as `doc`
        this.activeCommentID = doc.id
        this.activeParagraphId = doc.id

        // 1) DOM is always freshest (panel edit may have patched it)
        const domText =
          doc.querySelector('.comment-container')?.textContent?.trim() || ''

        // 2) Fallback to our local array if DOM has nothing
        const existing = this.commentsArray.find(
          (c) => c.commentParentID === doc.id
        )
        const storedText = existing?.comment || ''

        // set props first…
        this.activeCommentText = domText || storedText || ''
        // …then open on next tick so the dialog seeds correctly
        this.$nextTick(() => {
          this.commentDialogOpen = true
        })
      },
      onDialogSave({ paragraphId, comment }) {
        // Reuse your proven saveComment() path
        this.activeCommentID = paragraphId
        this.selectedComment = comment
        this.savingComment = true
        this.saveComment() // will close & reset below
      },
      onDialogCancel() {
        this.commentDialogOpen = false
      },
      updateComment(ID, comment) {
        // loop through the comments array to find a match
        let theComment = this.commentsArray.filter((el) => {
          if (el.commentParentID === ID) return el.comment

          return
        })

        if (theComment.length > 0) {
          theComment = theComment[0].comment
        } else {
          theComment = comment
        }

        // add the match to the div
        let doc = document.getElementById(ID)
        let theDiv = doc.getElementsByClassName('comment-container')

        while (theDiv[0].firstChild) {
          theDiv[0].removeChild(theDiv[0].firstChild)
        }

        // add the comment inside the div
        let textNode = document.createTextNode(theComment)
        theDiv[0].append(textNode)

        // show the comment
        if (theComment) doc.classList.add('active')
      },
      ensureCommentChrome(el) {
        if (!el || !el.id) return

        // ensure marker class
        el.classList.add('allow-commenting')

        // icon (create only if missing)
        let icon = el.querySelector(':scope > .comment-icon-container')
        if (!icon) {
          icon = document.createElement('span')
          icon.className = 'comment-icon-container'
          el.insertBefore(icon, el.firstChild)
          icon.addEventListener('click', () => this.openCommentModule(el))
        }

        // container (create only if missing)
        let box = el.querySelector(':scope > .comment-container')
        if (!box) {
          box = document.createElement('span')
          box.className = 'comment-container'
          el.insertBefore(box, icon.nextSibling)
        }

        // hydrate text from local cache
        const match = this.commentsArray.find(
          (c) => c.commentParentID === el.id
        )
        const text =
          (match &&
            typeof match.comment === 'string' &&
            match.comment.trim()) ||
          ''
        box.textContent = text
        el.classList.toggle('active', !!text)

        // hover listeners (idempotent – they won’t duplicate)
        if (!el._cmHoverBound) {
          el.addEventListener('mouseover', (e) => {
            const p = e.currentTarget
            if (p.id) p.classList.add('showCommentIcon')
          })
          el.addEventListener('mouseleave', (e) => {
            e.currentTarget.classList.remove('showCommentIcon')
          })
          el._cmHoverBound = true
        }
      },

      // run through paragraphs in content areas and *repair* only what’s missing
      commentHandler() {
        const root =
          (this.containerRef &&
            (this.containerRef.$el || this.containerRef.value)) ||
          this.$el ||
          document

        const paragraphs = root.querySelectorAll(
          '.p-content-container p, #footer-section p'
        )
        paragraphs.forEach((el) => {
          if (!el.id) return
          this.ensureCommentChrome(el)
        })
      },

      // small debounce so comment chrome runs after any DOM write
      commentHandlerDebounced: null,

      saveComment() {
        // console.log('saveComment ', unit)
        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id
        let comment = this.selectedComment
        let commentParentID = this.activeCommentID

        var commentcontentRef = db.collection('coursecontent')
        commentcontentRef = commentcontentRef.where('courseID', '==', courseID)
        commentcontentRef = commentcontentRef.where(
          'sectionID',
          '==',
          sectionID
        )
        commentcontentRef = commentcontentRef.where('unitID', '==', unitID)
        commentcontentRef = commentcontentRef.where(
          'commentParentID',
          '==',
          commentParentID
        )
        commentcontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                if (comment == '') {
                  // if no span tags remove the document
                  doc.ref.delete()
                  // hide the comment container
                  let theOgDoc = document.getElementById(commentParentID)
                  theOgDoc.classList.remove('active')
                } else {
                  // found comment so update the document
                  doc.ref.update({
                    comment: comment,
                  })
                }

                // update the array
                const item = this.commentsArray.find(
                  (it) => it.commentParentID == commentParentID
                )
                if (item) item.comment = comment

                this.updateComment(commentParentID, comment)
              })
            } else {
              // console.log("No such document!")
              db.collection('coursecontent').add({
                courseID: courseID,
                sectionID: sectionID,
                unitID: unitID,
                commentParentID: commentParentID,
                comment: comment,
              })

              this.commentsArray.push({
                courseID: courseID,
                sectionID: sectionID,
                unitID: unitID,
                commentParentID: commentParentID,
                comment: comment,
              })

              this.updateComment(commentParentID, comment)
            }
          })
          .then(() => {
            this.showComment = false // legacy
            this.commentDialogOpen = false // new dialog
            this.savingComment = false
          })
          .catch((error) => {
            console.log('Error getting document:', error)
            this.savingComment = false
          })
      },
      getParentKey(sel) {
        const inCommentChrome = (node) => {
          const el = node?.nodeType === 1 ? node : node?.parentElement
          return !!el?.closest?.('.comment-container, .comment-icon-container')
        }

        // If selection begins/ends in the comment UI, block highlighting
        if (
          !sel ||
          inCommentChrome(sel.anchorNode) ||
          inCommentChrome(sel.focusNode)
        ) {
          this.showToolbar = false // hide if your toolbar was shown
          return [{ parent: null, key: null }]
        }
        const base = sel?.anchorNode || sel?.baseNode
        if (!base) return [{ parent: null, key: null }]

        const root =
          (base.nodeType === 1 ? base : base.parentElement) ||
          (sel.anchorNode && sel.anchorNode.parentElement)

        const section = root?.closest?.('.p-content-container, #footer-section')
        if (!section) return [{ parent: null, key: null }]

        const findAllowedBlock = (node) => {
          let el = node?.nodeType === 1 ? node : node?.parentElement
          if (!el) return null
          const p = el.closest?.('p')
          if (p && section.contains(p)) return p
          const li = el.closest?.('li')
          if (li && section.contains(li)) return li
          const sq = el.closest?.('.study-question-statement')
          if (sq && section.contains(sq)) return sq
          const verse = el.closest?.('.verse-container')
          if (verse && section.contains(verse)) {
            const firstDiv = verse.querySelector(':scope > div')
            if (firstDiv && firstDiv.contains(el)) return firstDiv
          }
          return null
        }

        const parent = findAllowedBlock(base)
        let key = parent?.id || null

        // ensure .study-question-statement has an id at save time
        if (
          parent &&
          parent.classList?.contains('study-question-statement') &&
          !parent.id &&
          section
        ) {
          const sid = section.id || 'section'
          parent.id = this.mintNextId(section, `${sid}-sqs-`)
          key = parent.id // <-- make sure saveHighlight gets the new id
        }

        return [{ parent, key }]
      },
      // put this in methods (or wherever assignBlockIDs lives)
      assignBlockIDs() {
        const sections = document.querySelectorAll(
          '.p-content-container, #footer-section'
        )

        sections.forEach((section) => {
          const sid = section.id || 'section'

          // helper to mint sequential ids within this section
          const mint = (prefix) => {
            const taken = new Set(
              Array.from(section.querySelectorAll(`[id^="${prefix}"]`)).map(
                (el) => el.id
              )
            )
            let i = 0
            while (taken.has(`${prefix}${i}`)) i++
            return `${prefix}${i}`
          }

          // paragraphs
          section.querySelectorAll('p').forEach((el) => {
            if (!el.id) el.id = mint(`${sid}-p-`)
          })

          // list items
          section.querySelectorAll('li').forEach((el) => {
            if (!el.id) el.id = mint(`${sid}-li-`)
          })

          // verse-container first div
          section.querySelectorAll('.verse-container').forEach((vc) => {
            const firstDiv = vc.querySelector(':scope > div')
            if (firstDiv && !firstDiv.id) firstDiv.id = mint(`${sid}-verse-`)
          })

          // study question statements  ✅ NEW
          section
            .querySelectorAll('.study-question-statement')
            .forEach((sq) => {
              if (!sq.id) sq.id = mint(`${sid}-sqs-`)
            })
        })
      },
      mintNextId(sectionEl, prefix) {
        const taken = new Set(
          Array.from(sectionEl.querySelectorAll(`[id^="${prefix}"]`)).map(
            (el) => el.id
          )
        )
        let i = 0
        while (taken.has(`${prefix}${i}`)) i++
        return `${prefix}${i}`
      },
      applySavedBlocks(savedBlocks, attempts = 12) {
        // Try every ~100ms until the elements exist (up to ~1.2s total)
        const applyNow = () => {
          let pending = 0
          savedBlocks.forEach(({ id, html }) => {
            const el = document.getElementById(id)
            if (el) {
              el.innerHTML = html
            } else {
              pending++
            }
          })

          if (pending > 0 && attempts > 0) {
            setTimeout(() => applyNow(--attempts), 100)
          }
        }

        // Run after the current DOM tick as well
        this.$nextTick(applyNow)
      },
      // old: async saveHighlight(sel, action) {
      async saveHighlight(sel, action, opts = {}) {
        const courseID = this.$route.params.courseID
        const sectionID = this.$route.params.sectionID
        const unitID = this.$route.params.id

        // prefer explicit element/key (from onChange/removeHighlight)
        let paragraphEl = opts.paragraphEl || null
        let key = opts.key || null

        // fallback to selection-based lookup when needed
        if (!paragraphEl || !key) {
          const [{ parent, key: k }] = this.getParentKey(sel)
          paragraphEl = parent
          key = k
        }

        if (!paragraphEl || !key) {
          console.log('no key/element for saveHighlight')
          return null
        }

        // strip comment artifacts before saving
        const sanitizedText = paragraphEl.innerHTML
          .replace(
            /<(?:div|span)[^>]*class="comment-container"[^>]*>[\s\S]*?<\/(?:div|span)>/gi,
            ''
          )
          .replace(
            /<(?:div|span)[^>]*class="comment-icon-container"[^>]*>[\s\S]*?<\/(?:div|span)>/gi,
            ''
          )

        // do we still have at least one highlight span?
        const hasAnyHighlight =
          /<span[^>]*class="[^"]*\bhighlighted\b[^"]*"[^>]*>/i.test(
            sanitizedText
          )

        let ref = db
          .collection('coursecontent')
          .where('courseID', '==', courseID)
          .where('sectionID', '==', sectionID)
          .where('unitID', '==', unitID)
          .where('paragraphID', '==', key)

        try {
          const snapshot = await ref.get()

          if (!hasAnyHighlight) {
            // no highlights left in this block → delete any paragraph docs
            if (!snapshot.empty) {
              const batch = db.batch()
              snapshot.forEach((doc) => batch.delete(doc.ref))
              await batch.commit()
            }
            this.showTools = false
            return null
          }

          // upsert this paragraph’s HTML (single doc per paragraphID)
          if (!snapshot.empty) {
            const doc = snapshot.docs[0]
            await doc.ref.update({ paragraph: sanitizedText })
            this.showTools = false
            this.commentHandlerDebounced()
            return doc.id
          } else {
            const docRef = await db.collection('coursecontent').add({
              courseID,
              sectionID,
              unitID,
              paragraphID: key,
              paragraph: sanitizedText,
              createdAt: new Date(),
            })
            this.showTools = false
            return docRef.id
          }
        } catch (err) {
          console.log('Error getting/setting document:', err)
          return null
        }
      },
      freshenUpParagraphs(key, sel) {
        let editedParagraph = document.getElementById(key)
        // editedParagraph.innerHTML = sel.anchorNode.innerHTML
        // this.init(key)

        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id

        let contentRef = db.collection('coursecontent')
        contentRef = contentRef.where('courseID', '==', courseID)
        contentRef = contentRef.where('sectionID', '==', sectionID)
        contentRef = contentRef.where('unitID', '==', unitID)
        contentRef = contentRef.where('paragraphID', '==', key)
        contentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                // console.log('1 ', doc.data())
                editedParagraph.innerHTML = doc.data().paragraph
                // console.log('2 ', editedParagraph)
              })
            } else {
              editedParagraph.innerHTML = sel.anchorNode.innerHTML
              // console.log('3 ', editedParagraph.innerHTML)
            }
          })
          .then(() => {
            if (
              this.$store.getters['UserData/getRoles'].includes('tester') ||
              this.$store.getters['AppData/getFeatures'].includes('comments')
            )
              this.commentHandlerDebounced()
          })
      },
      findFootNotes() {
        if (
          this.$store.getters['UserData/getRoles'].includes('tester') ||
          this.$store.getters['AppData/getFeatures'].includes('footnotes')
        ) {
          let searchTerm = /\*/g
          let replaceTxt = '*'
          let replacementTerm =
            '<i class="footer-section">' + replaceTxt + '</i>'

          let truthBodyContentReplacement =
            this.unit.truthBodyContent.replaceAll(searchTerm, replacementTerm)
          this.unit.truthBodyContent = truthBodyContentReplacement
          let truthInBibleReplacement = this.unit.truthInBible.replaceAll(
            searchTerm,
            replacementTerm
          )
          this.unit.truthInBible = truthInBibleReplacement
          let equipBodyContentReplacement =
            this.unit.equipBodyContent.replaceAll(searchTerm, replacementTerm)
          this.unit.equipBodyContent = equipBodyContentReplacement
          let accountBodyContentReplacement =
            this.unit.accountBodyContent.replaceAll(searchTerm, replacementTerm)
          this.unit.accountBodyContent = accountBodyContentReplacement
          let missionBodyContentReplacement =
            this.unit.missionBodyContent.replaceAll(searchTerm, replacementTerm)
          this.unit.missionBodyContent = missionBodyContentReplacement
          let supplicationBodyContentReplacement =
            this.unit.supplicationBodyContent.replaceAll(
              searchTerm,
              replacementTerm
            )
          this.unit.supplicationBodyContent = supplicationBodyContentReplacement
        }

        setTimeout(() => {
          if (
            this.$store.getters['UserData/getRoles'].includes('tester') ||
            this.$store.getters['AppData/getFeatures'].includes('footnotes')
          ) {
            let elements = document.getElementsByClassName('footer-section')
            // console.log('2 ', elements.length)
            for (var i = 0; i < elements.length; i++) {
              // console.log('elements ', elements[i])
              elements[i].addEventListener('click', () => {
                this.scrollToTop('footer-section')
              })
            }
          }

          // after we look for the footnotes links, call the comment handler
          if (
            this.$store.getters['UserData/getRoles'].includes('tester') ||
            this.$store.getters['AppData/getFeatures'].includes('comments')
          )
            this.commentHandlerDebounced()
        }, 100)
      },
      refresh(key) {
        this.backdoor++

        // 1) If the element is in the DOM, we can restore it there directly.
        const el = document.getElementById(key)
        if (el) {
          // If you want to fetch from DB instead of using innerText, you can mirror freshenUpParagraphs here.
          // For now, just leave the element alone or set to its current text to clean stray nodes if needed:
          // el.innerHTML = el.textContent
          return
        }

        // 2) Legacy fallback: rebuild bound strings
        const regex = new RegExp(
          /<([^\s]+).*?id="([^"]*?)".*?>(.+?)<\/\1>|<img[^>]* src="([^"]*)"[^>]*>|<([^\s]+).*?>(.+?)<\/\5>/gi
        )

        const which = key.split('-')

        let arrayOfParagraphs = []
        if (which[1] == 'tbc')
          arrayOfParagraphs = this.unit.truthBodyContent.match(regex)
        if (which[1] == 'ibc')
          arrayOfParagraphs = this.unit.truthInBible.match(regex)
        if (which[1] == 'ebc')
          arrayOfParagraphs = this.unit.equipBodyContent.match(regex)
        if (which[1] == 'abc')
          arrayOfParagraphs = this.unit.accountBodyContent.match(regex)
        if (which[1] == 'mbc')
          arrayOfParagraphs = this.unit.missionBodyContent.match(regex)
        if (which[1] == 'sbc')
          arrayOfParagraphs = this.unit.supplicationBodyContent.match(regex)
        if (which[1] == 'fbc')
          arrayOfParagraphs = this.unit.footnotesBodyContent.match(regex)

        const searchterm = 'id="' + key + '"'

        for (let i = 0; i < arrayOfParagraphs.length; i++) {
          if (arrayOfParagraphs[i].search(searchterm) !== -1) {
            const clean = arrayOfParagraphs[i].replace(/(<([^>]+)>)/gi, '')
            // Do not force a <p>; just replace inner content
            arrayOfParagraphs[i] = arrayOfParagraphs[i].replace(
              />([\s\S]*?)</,
              '>' + clean + '<'
            )
          }
        }
        if (which[1] == 'tbc')
          this.unit.truthBodyContent = arrayOfParagraphs.join('').toString()
        if (which[1] == 'ibc')
          this.unit.truthInBible = arrayOfParagraphs.join('').toString()
        if (which[1] == 'ebc')
          this.unit.equipBodyContent = arrayOfParagraphs.join('').toString()
        if (which[1] == 'abc')
          this.unit.accountBodyContent = arrayOfParagraphs.join('').toString()
        if (which[1] == 'mbc')
          this.unit.missionBodyContent = arrayOfParagraphs.join('').toString()
        if (which[1] == 'sbc')
          this.unit.supplicationBodyContent = arrayOfParagraphs
            .join('')
            .toString()
        if (which[1] == 'fbc')
          this.unit.footnotesBodyContent = arrayOfParagraphs.join('').toString()
      },
      init(key) {
        const savedBlocks = []

        this.backdoor++

        let courseID = this.$route.params.courseID
        let sectionID = this.$route.params.sectionID
        let unitID = this.$route.params.id

        this.commentsArray = []

        var coursecontentRef = db.collection('coursecontent')
        coursecontentRef = coursecontentRef.where('courseID', '==', courseID)
        coursecontentRef = coursecontentRef.where('sectionID', '==', sectionID)
        coursecontentRef = coursecontentRef.where('unitID', '==', unitID)
        coursecontentRef
          .get()
          .then((snapshot) => {
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                let uu = doc.data()
                if (
                  uu.listenConfirmed ||
                  uu.completeConfirmed ||
                  uu.continueConfirmed
                ) {
                  uu.id = doc.id
                  this.userUnit.push(uu)
                  this.listenConfirmed = uu.listenConfirmed
                  this.completeConfirmed = uu.completeConfirmed
                  this.continueConfirmed = uu.continueConfirmed
                }

                if (uu.unitActive !== undefined) {
                  // check if the unit has been archived
                  this.unitStatus = uu.unitActive ? 'active' : 'archived'
                  this.unitActive = uu.unitActive
                }

                if (uu.paragraphID && uu.paragraphID !== null) {
                  savedBlocks.push({ id: uu.paragraphID, html: uu.paragraph })
                  // try DOM-first: update the element we actually saved
                  this.$nextTick(() => {
                    const el = document.getElementById(uu.paragraphID)
                    if (el) {
                      el.innerHTML = uu.paragraph
                      return
                    }

                    // Fallback: rebuild the section strings (legacy path)
                    const regex = new RegExp(
                      /<([^\s]+).*?id="([^"]*?)".*?>(.+?)<\/\1>|<img[^>]* src="([^"]*)"[^>]*>|<([^\s]+).*?>(.+?)<\/\5>/gi
                    )

                    const which = uu.paragraphID.split('-')
                    let arrayOfParagraphs = []
                    if (which[1] == 'tbc')
                      arrayOfParagraphs =
                        this.unit.truthBodyContent.match(regex)
                    if (which[1] == 'ibc')
                      arrayOfParagraphs = this.unit.truthInBible.match(regex)
                    if (which[1] == 'ebc')
                      arrayOfParagraphs =
                        this.unit.equipBodyContent.match(regex)
                    if (which[1] == 'abc')
                      arrayOfParagraphs =
                        this.unit.accountBodyContent.match(regex)
                    if (which[1] == 'mbc')
                      arrayOfParagraphs =
                        this.unit.missionBodyContent.match(regex)
                    if (which[1] == 'sbc')
                      arrayOfParagraphs =
                        this.unit.supplicationBodyContent.match(regex)
                    if (which[1] == 'fbc')
                      arrayOfParagraphs =
                        this.unit.footnotesBodyContent.match(regex)

                    const searchterm = 'id="' + uu.paragraphID + '"'

                    for (let i = 0; i < arrayOfParagraphs.length; i++) {
                      if (arrayOfParagraphs[i].search(searchterm) !== -1) {
                        // keep your legacy wrap for paragraphs, but don’t force <p> for non-<p> ids
                        // since we don’t know the tag from the string reliably, just drop in uu.paragraph
                        // (uu.paragraph already contains the child markup including <span class="highlighted">)
                        arrayOfParagraphs[i] = arrayOfParagraphs[i].replace(
                          />([\s\S]*?)</,
                          '>' + uu.paragraph + '<'
                        )
                      }
                    }

                    if (which[1] == 'tbc')
                      this.unit.truthBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'ibc')
                      this.unit.truthInBible = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'ebc')
                      this.unit.equipBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'abc')
                      this.unit.accountBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'mbc')
                      this.unit.missionBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'sbc')
                      this.unit.supplicationBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                    if (which[1] == 'fbc')
                      this.unit.footnotesBodyContent = arrayOfParagraphs
                        .join('')
                        .toString()
                  })
                } else {
                  if (key) this.refresh(key)
                }

                if (uu.commentParentID && uu.commentParentID !== null) {
                  this.commentsArray.push(uu)
                }
              })
            } else {
              // if snapshot is empty and we have a key lets refresh the paragraph to clean up the node
              if (key) this.refresh(key)
            }
          })
          .then(() => {
            // console.log('then after ', key)

            // update the status of the unit
            this.unit.status = this.unitStatus

            /*
             * for TESTERS only
             * Remove the isTester code below to open both
             * the footnotes links and the comment engine up to everyone
             */

            // call the footnotes links first then
            // we call the comment handler after the footnotes completes
            this.findFootNotes()

            // init the Cross reference code.
            // the main script can be found in the index.html
            window.dispatchEvent(new Event('esv-crossref.trigger-linkify'))

            // ensure blocks all have ids, then apply saved html
            this.$nextTick(() => {
              this.assignBlockIDs()
              // Give child components (e.g., UserStudyQuestions) a moment to render
              this.applySavedBlocks(savedBlocks)

              // (optional) re-run comments wiring after the DOM is updated
              if (
                this.$store.getters['UserData/getRoles'].includes('tester') ||
                this.$store.getters['AppData/getFeatures'].includes('comments')
              ) {
                this.commentHandlerDebounced()
              }
            })
          })
      },
      getSelectionContext() {
        const sel = window.getSelection?.()
        if (!sel || !sel.rangeCount || sel.isCollapsed) return null
        const range = sel.getRangeAt(0)
        const start =
          range.startContainer.nodeType === 1
            ? range.startContainer
            : range.startContainer.parentElement
        if (!start) return null

        // determine mode and paragraph
        const highlight = start.closest && start.closest('.highlighted')
        const paragraphEl = start.closest && start.closest('[id]')
        const excerpt = (range.cloneContents().textContent || '')
          .trim()
          .slice(0, 140)
        const currentColor =
          (highlight &&
            highlight.dataset &&
            highlight.dataset.highlightColor) ||
          '#ffeb3b'

        return {
          mode: highlight ? 'remove' : 'add',
          excerpt,
          currentColor,
          blockId: paragraphEl && paragraphEl.id,
          highlightNode: highlight || null,
        }
      },

      // Tap on existing highlight (no selection) → open Modify sheet (mobile only)
      onHighlightTap(e) {
        const el = e.target?.closest?.('.highlighted')
        if (!el) return

        // prevent bubbling/selection collapse
        e.preventDefault()
        e.stopPropagation()

        // ✅ Call the composable’s helper
        this.showToolbarForHighlightNode(el)
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped>
  .edit-user-unit-container.blueYear :deep(a) {
    color: #002b45 !important;
  }
  .v-theme--dark .edit-user-unit-container.blueYear :deep(a) {
    color: #758ca6 !important;
  }
  .edit-user-unit-container.redYear :deep(a) {
    color: #6e273d !important;
  }
  .v-theme--dark .edit-user-unit-container.redYear :deep(a) {
    color: #a26f7b !important;
  }
  .edit-user-unit-container.greenYear :deep(a) {
    color: #024731 !important;
  }
  .v-theme--dark .edit-user-unit-container.greenYear :deep(a) {
    color: #5e8372 !important;
  }
  .flex-this {
    display: flex;
  }
  .edit-user-unit-container {
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    max-height: calc(100vh - 250px);
    padding-bottom: 25%;
    scroll-behavior: smooth;
  }
  .edit-user-unit-container::-webkit-scrollbar {
    display: none;
  }
  .edit-user-unit-container :deep(img) {
    max-width: 100%;
  }
  .unit-assignments :deep(p) {
    margin-bottom: 0;
  }
  .unit-assignments .label-text :deep(p + p) {
    margin-top: 0.5rem;
  }
  .unit-assignments :deep(label) {
    text-transform: none;
  }
  .unit-assignments ._flex-this {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
  }
  .unit-assignments ._flex-this > div:first-child {
    flex: 0 0 7.5rem;
    width: 7.5rem;
    min-width: 7.5rem;
    max-width: 7.5rem;
  }
  .unit-assignments .assignment-checkbox-input {
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
  }
  .unit-assignments :deep(.v-checkbox.v-input) {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-inline-end: 0;
    --v-input-control-height: 24px;
  }
  .unit-assignments :deep(.v-checkbox .v-input__control) {
    min-height: 0;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control) {
    min-height: 0;
    align-items: flex-start;
    column-gap: 8px;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control__wrapper),
  .unit-assignments :deep(.v-checkbox .v-selection-control__input) {
    width: 18px;
    height: 18px;
  }
  .unit-assignments :deep(.v-checkbox .v-selection-control--density-compact) {
    --v-selection-control-size: 18px;
  }
  .unit-assignments :deep(.v-checkbox .v-label) {
    white-space: nowrap;
    padding-top: 0;
    padding-inline-start: 0;
    line-height: 1.2;
  }
  .unit-assignments :deep(.v-checkbox .font-weight-bold) {
    white-space: nowrap;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled) {
    opacity: 1;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled .v-label) {
    color: rgba(var(--v-theme-on-background), var(--v-high-emphasis-opacity));
    opacity: 1;
  }
  .unit-assignments :deep(.v-checkbox.v-input--disabled .v-selection-control__input) {
    opacity: var(--v-disabled-opacity);
  }
  .unit-assignments .label-text {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 13px;
    line-height: 1.5;
    padding-top: 0;
  }
  .unit-assignments :deep(.v-input__slot) {
    align-items: start;
  }
  @media only screen and (max-width: 959px) {
    .unit-assignments ._flex-this {
      align-items: flex-start;
      gap: 12px;
    }
  }
  @media only screen and (max-width: 599px) {
    .unit-assignments ._flex-this {
      gap: 10px;
    }
    .unit-assignments .label-text {
      font-size: 12px;
    }
  }
  button.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).blueYear {
    background-color: #002b45;
    border-color: #002b45;
    color: #ffffff;
  }
  button.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).redYear {
    background-color: #6e273d;
    border-color: #6e273d;
    color: #ffffff;
  }
  button.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
      .v-btn--outlined
    ).greenYear {
    background-color: #024731;
    border-color: #024731;
    color: #ffffff;
  }
  .v-alert.blueYear {
    background-color: #5b6d81;
    border-color: #5b6d81;
  }
  .v-alert.redYear {
    background-color: #a26f7b;
    border-color: #a26f7b;
  }
  .v-alert.greenYear {
    background-color: #5e8372;
    border-color: #5e8372;
  }
  .edit-user-unit-container :deep(.snippet-autosave-header) {
    padding: 0px;
  }
  /* add this if not already present for desktop */
  .edit-user-unit-container {
    position: relative; /* important for absolute toolbar positioning */
  }

  /* spans or divs – both ok */
  .edit-user-unit-container :deep(.comment-container),
  .edit-user-unit-container :deep(.comment-icon-container) {
    display: block; /* prevent line breaks from doing weird things */
  }
  .edit-user-unit-container :deep(.comment-container),
  .edit-user-unit-container :deep(.comment-icon-container) {
    user-select: none;
    -webkit-user-select: none;
  }
  .edit-user-unit-container :deep(.p-content-container),
  .edit-user-unit-container :deep(#footer-section) {
    -webkit-user-select: text;
    user-select: text;
  }
  .edit-user-unit-container :deep(.comment-container) {
    opacity: 0;
    height: 0;
  }
  .edit-user-unit-container :deep(.active .comment-container) {
    opacity: 1;
    width: auto;
    position: relative;
    top: -5px;
    border-radius: 4px;
    padding: 10px;
    color: #fff;
    height: auto;
  }
  .edit-user-unit-container.blueYear :deep(.comment-container) {
    background: #002b45;
  }
  .edit-user-unit-container.redYear :deep(.comment-container) {
    background: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(.comment-container) {
    background: #024731;
  }
  .edit-user-unit-container :deep(.active .comment-container:after) {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -5px;
    transform: translateX(-50%);
    width: 0px;
    height: 0px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  }
  .edit-user-unit-container.blueYear :deep(.comment-container:after) {
    border-top: 6px solid #002b45;
  }
  .edit-user-unit-container.redYear :deep(.comment-container:after) {
    border-top: 6px solid #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(.comment-container:after) {
    border-top: 6px solid #024731;
  }
  .button-group {
    display: flex;
    align-items: center;
  }
  svg.note-icon :deep(path) {
    fill: #fff;
  }
  .seperator {
    background: rgba(255, 255, 255, 1.2);
    width: 1px;
    height: 20px;
    margin: 0 10px;
  }
  .p-content-container :deep(p),
  .user-study-questions-container,
  #footer-section :deep(p) {
    padding-right: 40px;
  }
  .edit-user-unit-container :deep(.footer-section) {
    cursor: pointer;
    font-weight: 900;
    text-decoration: underline;
  }
  .edit-user-unit-container.blueYear :deep(.footer-section) {
    color: #002b45;
  }
  .edit-user-unit-container.redYear :deep(.footer-section) {
    color: #6e273d;
  }
  .edit-user-unit-container.greenYear :deep(.footer-section) {
    color: #024731;
  }
  .bg-dark-toolbar {
    background-color: #383935 !important;
  }
  /* ensure the sheet/overlay wins over custom fixed headers/toolbars */
  .v-overlay {
    z-index: 10010 !important;
  }

  .tj-mobile-pill {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 16px;
    z-index: 9999;
    pointer-events: auto;
  }

  .tj-mobile-pill,
  .tj-mobile-pill * {
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }

  @media only screen and (max-width: 767px) {
    .edit-user-unit-container {
      padding-bottom: 50%;
      position: fixed;
      top: 230px;
      left: 0;
    }
    .edit-user-unit-container.top-38 {
      top: 268px;
    }
    .edit-user-unit-container {
      transition: 0.4s ease;
    }
    .hide-title .edit-user-unit-container {
      top: 130px;
      max-height: calc(100vh - 190px);
    }
    .hide-title .edit-user-unit-container.top-38 {
      top: 168px;
    }
    .flex-this {
      flex-direction: column;
    }
  }
</style>
